import Canvas from './Canvas'
import { Wrapper } from './Wrapper'
import { ClientOwnershipDefault } from './defaults/ClientOwnershipDefault'
import { Settings } from './Settings'
import { AddNodeSidebar } from './AddNodeSidebar'
import { SaveControls } from './SaveControls'
import { StyleEditSidebar } from './StyleEditSidebar'
import { LinkEditSidebar } from './LinkEditSidebar'
import { DetailsSidebar } from './DetailsSidebar'

export const EntityGraphComponents = {
  EG_ClientOwnershipDefault: ClientOwnershipDefault,
  EG_Canvas: Canvas,
  EG_Wrapper: Wrapper,
  EG_Settings: Settings,
  EG_AddNodeSidebar: AddNodeSidebar,
  EG_StyleEditSidebar: StyleEditSidebar,
  EG_LinkEditSidebar: LinkEditSidebar,
  EG_SaveControls: SaveControls,
  EG_DetailsSidebar: DetailsSidebar
}
